import { useCallback, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useResetPassword } from '@Hooks/Api';
import { useNotificationsContext } from '@Contexts';
import { setBackendFieldErrors } from '@Helpers/setBackendFieldErrors';
import { PasswordReset } from './PasswordReset';

export const PasswordResetController = () => {
  const methods = useForm();
  const { handleSubmit, setError } = methods;
  const [resetPassword, { loading, error }] = useResetPassword();
  const [isSent, setIsSent] = useState(false);
  const { error: errorNotification } = useNotificationsContext();

  const onSubmit = useCallback(
    ({ email }: { email: string }) => {
      resetPassword(email)
        .then(() => {
          setIsSent(true);
        })
        .catch(({ data }) => {
          if (data?.field_errors) {
            setBackendFieldErrors(data.field_errors, setError);
          } else {
            errorNotification(
              data?.detail?.[0] || 'An error occurred while resetting your password',
            );
          }
        });
    },
    [errorNotification, resetPassword, setError],
  );

  return (
    <FormProvider {...methods}>
      <PasswordReset onSubmit={handleSubmit(onSubmit)} isLoading={loading} isSent={isSent} />
    </FormProvider>
  );
};
